<modal-layout-right [modalTitle]="product?.data.isProductProtectionPlan ? 'Care Plan' : ''">
    <div modalBody>
        <p sizeClass="SM: s1, XL: h4">{{product.name}}</p>
        @if (product?.data.care_plan_features) {
        <ul class="m-t-8 m-t-7-s">
            @for (item of product?.data.care_plan_features; track item) {
            <li class="m-b-5 m-b-2-s p1"><i class="icon-tick inline-block m-r-2 col-3"></i>{{item | optionLabel:
                'care_plan_features'}}</li>
            }
        </ul>
        }
        @if (product?.data?.plan_info) {
        <div class="m-t-8 m-t-7-s p2 col-11"
             [innerHTML]="product.data.plan_info">
        </div>
        }
    </div>
</modal-layout-right>
